import React, { Component, useState, useEffect } from "react";
import "../../Kiosk.css";
import Keyboard from "react-simple-keyboard";
import "react-simple-keyboard/build/css/index.css";
import {
  backActionRequest,
  idleErrorMessage,
  inputVerifyRequestAction,
  mrnSubmitRequest,
} from "../../../../store/actions";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { IkioskManager, IKioskModel } from "../../../../models/kioskModel";
import { Formik, Field, Form, ErrorMessage } from "formik";
import { customContentValidation } from "../../../../helpers/helpersIndex";
import * as Yup from "yup";
import { Row, Col } from "reactstrap";
import { interval } from "rxjs";
import { EStatusEnum } from "../../../../models/utilitiesModel";

let subscribe;
interface IProps {
  mrnSubmitRequest: any;
}

const MrnVerfication: React.FC = () => {
  const [layoutName, setLayoutName] = useState("default");
  const [keyboardopen, setKeyboardopen] = useState(false);
  const [mrn, setMrn] = useState("");

  let keyboard = React.createRef();
  const dispatch = useDispatch();
  const { t } = useTranslation("translations");

  const language = useSelector((state: any) => {
    if (state?.kioskReducer?.language)
      return (state.kioskReducer as IKioskModel).language;
    else return "";
  });

  // const appoinmntSubmit = () => {
  //     setKeyboardopen(false);
  //     console.log("appoinmntSubmit =>", mrn);
  //     dispatch(mrnSubmitRequest(mrn));
  // }

  const onChangeInput = (event) => {
    let input = event.target.value;
    setMrn(input);
  };

  const onChange = (input) => {
    setMrn(input);
  };

  const onKeyPress = (button) => {
    if (button === "{s}") handleShift();
    if (button === "{lock}" || button === "{locks}") handleLock();
  };

  const handleShift = () => {
    setLayoutName(layoutName === "default" ? "shift" : "default");
  };

  const handleLock = () => {
    setLayoutName(layoutName === "shift" ? "small" : "shift");
  };

  // const keyboardStatus = () => {
  //     setKeyboardopen(!keyboardopen);
  // }

  const layout = {
    default: ["1 2 3", "4 5 6", "7 8 9", "0 {bksp}"],
    shift: [
      "{tab} Q W E R T Y U I O P {bksp}",
      "{locks} A S D F G H J K L {enter}",
      "{shift} Z X C V B N M {shift}",
      "{s} . {space} , {s}",
    ],
    small: [
      "{tab} q w e r t y u i o p {bksp}",
      "{locks} a s d f g h j k l {enter}",
      "{shift} z x c v b n m {shift}",
      "{s} . {space} , {s}",
    ],
  };

  const display = {
    "{bksp}": "Delete",
    "{enter}": "Enter",
    "{shift}": "Shift",
    "{s}": "123",
    "{lock}": "ABC",
    "{space}": " ",
    "{tab}": "Tab",
    "{locks}": "CapsLock",
    "{//}": " ",
    "{return}": "Return",
  };
  const loading = useSelector(
    (state: any) => (state.kioskReducer as IKioskModel).loading
  );
  const isEnabledDobAuth = useSelector(
    (state: any) => (state.kioskReducer as IKioskModel)?.isEnabledDobAuth
  );
  const selectedArea = useSelector(
    (state: any) => (state.kioskReducer as IKioskModel).selectedArea
  );
  console.log("MrnVerficstionPage==>", isEnabledDobAuth, selectedArea);

  return (
    <>
      <div className="kiosk-content mrnstyle">
        <div className="content-sec nmbr_verification">
          {!loading && (
            <div className="number_chamber">
              <h1 className="">{t("Kiosk.MrnId" + language)}</h1>
              <Formik
                enableReinitialize
                initialValues={{
                  mrnNo: "",
                  keyboardopen: false,
                }}
                validationSchema={Yup.object().shape({
                  mrnNo: customContentValidation(
                    t,
                    t("controleErrors.required" + language),
                    {
                      patternType: "number",
                      message: "number" + language,
                      spacialChar: null,
                    } as any,
                    15,
                    2,
                    language
                  ),
                })}
                onSubmit={(values) => {
                  console.log("Values =>", values);
                  setKeyboardopen(false);
                  dispatch(mrnSubmitRequest(values.mrnNo));
                }}
              >
                {({
                  errors,
                  touched,
                  dirty,
                  values,
                  setFieldValue,
                  setFieldTouched,
                }) => (
                  <Form>
                    {console.log("hfusiivnis =>", values, errors, touched)}

                    <div>
                      <div>
                        <div className="">
                          <input
                            type="text"
                            name="mrnNo"
                            autoComplete="off"
                            onFocus={() => setFieldValue("keyboardopen", true)}
                            onBlur={() => setFieldTouched("mrnNo", true)}
                            value={values.mrnNo}
                            placeholder={t("Kiosk.mrnNoPlaceholder" + language)}
                            className={
                              "form-control mb-1 " +
                              (errors.mrnNo && touched.mrnNo
                                ? "is-invalid"
                                : "")
                            }
                            // onChange={(event) => setFieldValue('mrnNo', event.target.value)}
                            onChange={(e) => onChangeInput(e)}
                          />
                          <span className="info-message">
                            * {t("Kiosk.phoneNumberCountryCode" + language)}
                          </span>
                        </div>

                        <div className="mt-3">
                          {errors.mrnNo && touched.mrnNo && (
                            <div className="error-msg mt-0">
                              <span>{errors.mrnNo}</span>
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="pt-4 row_gap">
                        <button type="submit" className="btn submit-btn">
                          {t("Kiosk.submit" + language)}
                        </button>
                        <button
                          type="button"
                          className="btn submit-btn"
                          onClick={() => dispatch(backActionRequest())}
                        >
                          {t("Kiosk.cancel" + language)}
                        </button>
                      </div>
                    </div>

                    {values.keyboardopen && (
                      <Keyboard
                        display={display}
                        layout={layout}
                        layoutName={layoutName}
                        keyboardRef={(r) => (keyboard = r)}
                        onChange={(input) => setFieldValue("mrnNo", input)}
                        onKeyPress={(button) => onKeyPress(button)}
                        buttonTheme={[
                          {
                            class: "hg-grey",
                            buttons:
                              "Q W E R T Y U I O P A S D F G H J K L Z X C V B N M q w e r t y u i o p a s d f g h j k l z x c v b n m {space} 1 2 3 4 5 6 7 8 9 0",
                          },
                        ]}
                      />
                    )}
                  </Form>
                )}
              </Formik>
            </div>
          )}
          {/* {loading && <div className="appLoading pt-3"><div className="lds-ring"><div></div><div></div><div></div><div></div></div></div>} */}
        </div>
      </div>
    </>
  );
};

export default React.memo(MrnVerfication);
